import { z } from "zod";

/// URL-state for the survey detail page (S3). `view` picks the lens: Results
/// (run analytics, the default landing once a survey has fired) or Setup
/// (questions + configuration, the only lens drafts have). `run` and
/// `department` scope the Results lens; they also validate the legacy
/// /pulse-surveys/$surveyId/insights redirect alias, which forwards here.
export const pulseSurveyDetailSearchSchema = z.object({
  view: z.enum(["results", "setup"]).optional(),
  run: z.string().optional(),
  department: z.string().optional(),
});

export type PulseSurveyDetailSearch = z.infer<typeof pulseSurveyDetailSearchSchema>;

export type PulseSurveyDetailView = "results" | "setup";

/// Data-dependent default: drafts have nothing to report, so they land on
/// Setup; anything that has fired lands on Results for viewers who can see
/// them. Explicit `view` in the URL wins unless it points at a lens the
/// viewer can't use (Q11 defence-in-depth: clamp, don't trust the URL).
export function resolveDetailView(args: {
  view: PulseSurveyDetailSearch["view"];
  isDraft: boolean;
  canViewInsights: boolean;
}): PulseSurveyDetailView {
  if (args.isDraft || !args.canViewInsights) return "setup";
  return args.view ?? "results";
}
